module.exports = {
	"trips": [
		{
			"totalCost": 337.71,
			"arrivalDateTime": "2018-07-10T15:38:00",
			"numOfStops": 0,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-07-10T09:31:00",
			"destination": "ORD",
			"downPayment": 112.57,
			"id": "64c40927-e4c0-4d80-be4d-5436883ee7a1",
			"origin": "LAX",
			"ppnContractBundle": "_eJwFwTe2ozAAAMADuSAIjFxswSc9kRHJ0IloEz5JsKxOvzOK3Da12LyQ1uZj1rGhF2fzzpKkI5_plT27tS8yWK7zp_fclpxvfIN0r_pAa5lmikNTzHEKhK3QzZY2Bl3nVe8C9nwCbTX3IjKuBvL7Ch_fR3VMqYQ0_pVx4X_fNM6DTVYuu9D9TFZ7p9cCf86Z5hzPu_pDwbRyah78v03ZjK_pebskVHd1R7jJKwIR6VBFpH1P_pWXWQ2jubhWAJMq3Na20dXOfr3euXj_pcZZnxb24paPBoZ1uY97962nHd7zaCJqBvsvr68YRJ_pV6uAKYPyJySRBxsUzfYukc2rGlW_fYtvbKqtcMWRoomxKKu2HZzOFwPSaHCWplWVByuEOxx3haFCGBAh1Kqq2gMTpqEuc4wbjd6aJI_phesD9bMpCeRVSzc6ixkV_p4hik9yCUB5J6KTvQn_f8zQIWo",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-07-10T15:38:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NK.png",
					"carrierCode": "NK",
					"carrierName": "Spirit Airlines",
					"departureDateTime": "2018-07-10T09:31:00",
					"flightNumber": "730",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			]
		},
		{
			"totalCost": 337.71,
			"arrivalDateTime": "2018-07-10T15:38:00",
			"numOfStops": 0,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-07-10T09:31:00",
			"destination": "ORD",
			"downPayment": 112.57,
			"id": "b4b2745b-a4d3-4e22-a5d7-8e4abab660bd",
			"origin": "LAX",
			"ppnContractBundle": "_eJwFwUligjAUANADuYBGIHTRBShIGSSGIcrO_fASBqiCDCKfvewaSQpb8awJIfUsdGtkRFLJ1F5W1jlTkUvQQp7YiQonWLD_fqCs0MEq2lKlOslJ9_pHyoas8z88zyQ3tan41onpzMnNEJ6wl1yT5Kl_p76kozcMdbqtHofeF4HbBxGe74K2K_fYY8IuZtHnBjpsSXnKhzKYXLTk26LpWu5548L4xW7fgsaaBMW12UvtdSgFvsBJdjUXkgWJzx4Xr_faylMX_p42AaoFI8aU7EpRnOZuNyOuHsnlgqF8JiiGnuEkpf0jZeTB8TXwnaV_fEmpeYOF7H8pFBjyvpw1i3Bc1R5TzXxkQTayLP3EiLWHv25oYwrdX2OYt_pra2J8gcOLM0qcWDhHX6y3qURloTjwP8s1JpT8jJ2uc_fjr44a7YevNdOwn83axhbMPGMRvszKx3fv4B_p6KGKw",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-07-10T15:38:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NK.png",
					"carrierCode": "NK",
					"carrierName": "Spirit Airlines",
					"departureDateTime": "2018-07-10T09:31:00",
					"flightNumber": "730",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			]
		},
		{
			"totalCost": 398.4,
			"arrivalDateTime": "2018-07-10T15:27:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-07-10T06:05:00",
			"destination": "ORD",
			"downPayment": 132.8,
			"id": "c9d7800a-6f16-4eac-81e2-9990dcd8934f",
			"origin": "LAX",
			"ppnContractBundle": "_eJwFwVGDQjAAAOAf5MGwYg_f3QCJLWuy26m2NzpEQDvv1930od_pDGhHkujw41HHhxF13Goi4z7JXv5NHZcsY2bPTBDHL78c47QIRjmWp9BhSeFm_frn6thsgNxrLIaoYQ3aVEW1iiyaHez0nWJ57Bn5M4P3PRcs_f_fgayi4PZ9iQi9tk6K6GMu_fdXWF_fmCWKPoe5T_fbifa7BJkTmUh6cFn7Mu_pckGrC_fBQUi2febH5rMtrwix62UCVhwMvW1XF8F9snHF77Oak6JxQ_paZ5A_fZb5O9MiDFL1Hf3Ud21vL8PwCdiCBTq_pxsyOAdqc4zMsvbmrJByG1AmAi1Pi7DsaGv5WuqqK_f4CPU6v83THXQ4zeeHi5cAX8Gcxa141GXckQJOZV2c8zpzo6_pGbMSIp9thtUpKaIynoxxu_fDI7I2KEkg0bRXgNs0t1TDVkblIBmxuF6Az1v1mFl67ybIz6_pRrHJNtRM3Fvj1D_f4fjtw",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-07-10T07:16:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NK.png",
					"carrierCode": "NK",
					"carrierName": "Spirit Airlines",
					"departureDateTime": "2018-07-10T06:05:00",
					"flightNumber": "562",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"destination": "LAS",
					"destinationAirportName": "McCarran Intl Airport",
					"destinationAirportCity": "Las Vegas",
					"destinationAirportState": "NV",
					"destinationAirportCountry": "United States",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-07-10T15:27:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NK.png",
					"carrierCode": "NK",
					"carrierName": "Spirit Airlines",
					"departureDateTime": "2018-07-10T09:45:00",
					"flightNumber": "446",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "LAS",
					"originAirportName": "McCarran Intl Airport",
					"originAirportCity": "Las Vegas",
					"originAirportState": "NV",
					"originAirportCountry": "United States"
				}
			]
		},
		{
			"totalCost": 398.4,
			"arrivalDateTime": "2018-07-10T22:08:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-07-10T10:49:00",
			"destination": "ORD",
			"downPayment": 132.8,
			"id": "b8e251d3-1665-4263-9809-7187ea9c0d97",
			"origin": "LAX",
			"ppnContractBundle": "_eJwFwUmiQzAAANADZaE1W_fwFNdc8xLATQVGqkg56_pv8e7mWB6zB_pe_pGYiIwVf_pwtTdFhx2kvZVXGOlM_paABf4yySV0RDJpIhb5TZz3M_fShIurSb5zl2sVKuRY_p50MYxIUQoskRgmDcXZfodXdwtEYcsGunIlbC_fEw25Bu5xyo0_poZ5lA2pJajsLI4QLR0T_fN8K7cvVY_fR0UW90kyPDTSQfVbUn9r2zpmiRdYXhWiuf8pSBIjh33Gc91M6PV_pwVTxrB0VPKRAZBohubPn7qYT_fzBnbmJ26HvG_pjBHOBds3T4aMPi2Kesl4GXfC7TBS_pv1l7cImuFZJVbGauJShxPIX7UkcMqEpVLt1PN_pvYFqJGT9MamYRCLMg0t30pxoe_ft2mTyYauzKWTtLhRZ8UWPcHmUkhItHKGDlLeyYB8Qo6cuBLe67QzGy9K_pcANwbysTz_fjMQK_p4b0ybdgBow7amLmXo5GOSSv3_pwc45d",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-07-10T18:25:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NK.png",
					"carrierCode": "NK",
					"carrierName": "Spirit Airlines",
					"departureDateTime": "2018-07-10T10:49:00",
					"flightNumber": "403",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"destination": "ATL",
					"destinationAirportName": "Hartsfield-Jackson Atlanta Intl Airport",
					"destinationAirportCity": "Atlanta",
					"destinationAirportState": "GA",
					"destinationAirportCountry": "United States",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-07-10T22:08:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NK.png",
					"carrierCode": "NK",
					"carrierName": "Spirit Airlines",
					"departureDateTime": "2018-07-10T20:57:00",
					"flightNumber": "762",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "ATL",
					"originAirportName": "Hartsfield-Jackson Atlanta Intl Airport",
					"originAirportCity": "Atlanta",
					"originAirportState": "GA",
					"originAirportCountry": "United States"
				}
			]
		},
		{
			"totalCost": 398.4,
			"arrivalDateTime": "2018-07-10T22:08:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-07-10T10:49:00",
			"destination": "ORD",
			"downPayment": 132.8,
			"id": "11cd26b8-e1c2-4a6d-aa3c-d56967324f02",
			"origin": "LAX",
			"ppnContractBundle": "_eJwFwcmiazAAANAPegu0iizeAhc1ptXGtEukoTHUfMvX33NUepZKUZTGBw_ftzjiGPIBUs7_fJRwZgZxzv7NRuAvBsrzrugL_ppeUJPNx6x5XRLY_piTewtvpxRRMuiFDH_pyeVn17g7sizrC_pHp4QomU7BgJ_fRRs046gFm_f205aJAvofzWUP0IffYlEiOao9432lWguWyYqllFvpVh_ffZQcLBv5Mi0ZSCJyhyJdnBzMpMh_p4u0Oyo9LkAstaUs3busqo2YXBrXin5vrdjMR_fXHtlanclBVbWy2ZMls50JhTbDkAkSLLxVLqP2HsOMZdGB60bMwGwFeWk9jXXUfrEO2uQhRPibnJzfFoNMoLpOx7qZij9QcZCcJnozhnK1MgUpDRPzITWjj_pmK33zbNs66WT1snTuVOM6uZVr2HnxNdRyhJozBmFsZ0wvkQ8Gkwekzc3XrpXTrz_pY9YJfKsYxht7Dso_fyV9Ln_f3_fkgZGE",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-07-10T18:25:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NK.png",
					"carrierCode": "NK",
					"carrierName": "Spirit Airlines",
					"departureDateTime": "2018-07-10T10:49:00",
					"flightNumber": "403",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"destination": "ATL",
					"destinationAirportName": "Hartsfield-Jackson Atlanta Intl Airport",
					"destinationAirportCity": "Atlanta",
					"destinationAirportState": "GA",
					"destinationAirportCountry": "United States",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-07-10T22:08:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NK.png",
					"carrierCode": "NK",
					"carrierName": "Spirit Airlines",
					"departureDateTime": "2018-07-10T20:57:00",
					"flightNumber": "762",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "ATL",
					"originAirportName": "Hartsfield-Jackson Atlanta Intl Airport",
					"originAirportCity": "Atlanta",
					"originAirportState": "GA",
					"originAirportCountry": "United States"
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ../server/test/mocks/RoundTrip_Returning.json
// module id = 599
// module chunks = 0